import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getNotifications, markNotifRead, markAllNotifRead } from '../../services/api';

const TYPE_ICON = {
  NEW_APPOINTMENT:'📅', APPOINTMENT_UPDATED:'📝', APPOINTMENT_CANCELLED:'❌',
  APPOINTMENT_REMINDER:'⏰', NEW_INVOICE:'💰', PAYMENT_CONFIRMED:'✅', INVOICE_OVERDUE:'⚠️',
};
function timeAgo(d) {
  const s = Math.floor((Date.now()-new Date(d))/1000);
  if (s<60) return 'agora'; if (s<3600) return `${Math.floor(s/60)}min atrás`;
  if (s<86400) return `${Math.floor(s/3600)}h atrás`; return `${Math.floor(s/86400)}d atrás`;
}

export default function TenantNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [unread,  setUnread]  = useState(0);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);

  const load = () => {
    getNotifications()
      .then(r => { setNotifications(r.data.notifications); setUnread(r.data.unread_count); })
      .catch(() => toast.error('Erro ao carregar'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleRead = async n => {
    if (n.is_read) return;
    await markNotifRead(n.id).catch(() => {});
    setNotifications(p => p.map(x => x.id===n.id ? {...x, is_read:1} : x));
    setUnread(u => Math.max(0, u-1));
  };

  const handleReadAll = async () => {
    setMarking(true);
    await markAllNotifRead().catch(() => {});
    setNotifications(p => p.map(x => ({...x, is_read:1})));
    setUnread(0);
    toast.success('Todas marcadas como lidas');
    setMarking(false);
  };

  return (
    <div className="page-body">
      <div className="page-header-row">
        <div className="page-header">
          <h2>Notificações</h2>
          <p>{unread > 0 ? `${unread} não lida(s)` : 'Todas lidas'}</p>
        </div>
        {unread > 0 && (
          <button className={`btn btn-secondary btn-sm${marking?' btn-loading':''}`} onClick={handleReadAll} disabled={marking}>
            {marking ? 'Marcando...' : '✓ Marcar todas como lidas'}
          </button>
        )}
      </div>

      {loading ? <div className="spinner" style={{margin:'40px auto',display:'block'}} /> : (
        <div className="card">
          {notifications.length===0 ? (
            <div className="empty-state" style={{padding:48}}>
              <div className="empty-icon">🔔</div>
              <h3>Nenhuma notificação</h3>
              <p>Você será notificado sobre agendamentos, faturas e atualizações importantes.</p>
            </div>
          ) : (
            notifications.map(n => (
              <div key={n.id} className={`notif-item${!n.is_read?' unread':''}`} onClick={() => handleRead(n)}>
                <span className="notif-icon">{TYPE_ICON[n.type]||'🔔'}</span>
                <div style={{flex:1, minWidth:0}}>
                  <div className="notif-title">{n.title}</div>
                  <div className="notif-message">{n.message}</div>
                  <div className="notif-time">{timeAgo(n.created_at)}</div>
                </div>
                <div className={`notif-dot${n.is_read?' read':''}`} />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
